/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Consumption_Target_ReductionInputs */



/**
* | output |
* | --- |
* | "{percent}% reduction" |
*
* @param {Consumption_Target_ReductionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_target_reduction = /** @type {((inputs: Consumption_Target_ReductionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Target_ReductionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.percent}% reduction`)
	return /** @type {LocalizedString} */ (`Réduction de ${i?.percent} %`)
});